export const abortControllerEffect = (
  effect: (signal: AbortSignal) => void | (() => void),
) => {
  const controller = new AbortController()
  const cleanup = effect(controller.signal)

  return () => {
    controller.abort()
    cleanup?.()
  }
}
